import { AxiosInstance } from 'axios';
import { AppState } from '@/api/app-state/app-state.types.ts';

export const createAppStateApi = (api: AxiosInstance) => ({
  // Public endpoint. The Axios interceptor still attaches the bearer token when
  // present, so the backend narrows the announcement audience for known callers.
  getAppState: () => api.get<AppState>('/v1/app-state'),
});
